<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app" :class="vueAppClasses">
		<router-view @setAppClasses="setAppClasses" />
		<div>
			<vs-button
				radius
				color="primary"
				type="filled"
				icon="arrow_upward"
				style="position: fixed; right: 20px; bottom: 100px;  z-index: 10000"
				@click="scrollToTop"
				v-if="scrollToTopVisible"
			/>

		</div>
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js';

export default {
	data() {
		return {
			vueAppClasses: [],
			apiUrl: '',
			chat: {
				name: 'onbekend',
				email: 'onbekend',
				variables: {
					id: 'onbekend',
					company: 'onbekend',
					city: 'onbekend',
					retailer_id: 'onbekend',
					retailer_name: 'onbekend',
				}
			},
			checkTokenExpireTimer: null,
			tokenExpireMessages: {
				threeMinutes: {
					showed: false
				},
				twoMinutes: {
					showed: false
				},
				oneMinutes: {
					showed: false
				},
			},
			scrollToTopVisible: false,
		}
	},
	watch: {
		'$store.state.theme'(val) {
			this.toggleClassInBody(val)
		},
		'$vs.rtl'(val) {
			document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
		}
	},
	computed: {
		tokenExpireTimeStamp() {
			return this.$store.state.auth.expire_timestamp;
		},
		user() {
			return this.$store.state.userStore.user;
		},
		retailer() {
			return this.$store.state.retailerSetting.retailer;
		},
	},
	methods: {
		toggleClassInBody(className) {
			if (className === 'dark') {
				if (document.body.className.match('theme-semi-dark')) {
					document.body.classList.remove('theme-semi-dark');
				}

				document.body.classList.add('theme-dark')
			} else if (className === 'semi-dark') {
				if (document.body.className.match('theme-dark')) {
					document.body.classList.remove('theme-dark');
				}

				document.body.classList.add('theme-semi-dark')
			} else {
				if (document.body.className.match('theme-dark')) {
					document.body.classList.remove('theme-dark');
				}

				if (document.body.className.match('theme-semi-dark')) {
					document.body.classList.remove('theme-semi-dark');
				}
			}
		},
		setAppClasses(classesStr) {
			this.vueAppClasses.push(classesStr)
		},
		handleWindowResize() {
			this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

			// Set --vh property
			document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
		},
		handleScroll() {
			this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
		},
		pushChatData() {
			this.updateChatData();

			this.sendChatData();
		},
		updateChatData() {
			if (this.user) {
				this.chat.name = this.user.name;
				this.chat.email = this.user.email;
				this.chat.variables.id = this.user.id;
				this.chat.variables.company = this.user.company;
				this.chat.variables.city = this.user.city;
			} else if (this.chat.email === 'onbekend') {
				//to make sure user got a unique name we generate a random name. This name is used when not logged in.
				let userRandomName = localStorage.getItem('user_random_name');
				if (!userRandomName) {
					//if not in store generate an new random name.
					userRandomName = Math.random().toString(36).substring(2);
					localStorage.setItem('user_random_name', userRandomName);
				}
				this.chat.name = userRandomName;
			}

			if (this.retailer) {
				this.chat.variables.retailer_id = this.retailer.id;
				this.chat.variables.retailer_name = this.retailer.name;
			}
		},
		sendChatData() {
			// eslint-disable-next-line no-undef
			smartsupp('name', this.chat.name);
			// eslint-disable-next-line no-undef
			smartsupp('email', this.chat.email);
			// eslint-disable-next-line no-undef
			smartsupp('variables', this.chat.variables);
		},
		setCheckTokenExpireTimer(delay = 30000) {
			if (this.checkTokenExpireTimer) {
				clearTimeout(this.checkTokenExpireTimer);
			}

			this.checkTokenExpireTimer = setTimeout(this.checkTokenExpire, delay);
		},
		showLogoutNofify(diffInSec) {
			if (diffInSec < 10) {
				this.$store.dispatch('auth/signOut');
			} else if (diffInSec < 70) {
				if (!this.tokenExpireMessages.oneMinutes.showed) {
					this.logoutNotify('Je wordt in 1 minuut uitgelogd!', (diffInSec - 11) * 1000);

					this.logoutNowNotify((diffInSec - 10) * 1000);

					this.tokenExpireMessages.oneMinutes.showed = true;
				}
			} else if (diffInSec < 130) {
				if (!this.tokenExpireMessages.twoMinutes.showed) {
					this.logoutNotify('Je wordt in 2 minuten uitgelogd!', (diffInSec - 71) * 1000);

					this.tokenExpireMessages.twoMinutes.showed = true;
				}
			} else if (diffInSec < 190) {
				if (!this.tokenExpireMessages.threeMinutes.showed) {
					this.logoutNotify('Je wordt in 3 minuten uitgelogd!', (diffInSec - 131) * 1000);

					this.tokenExpireMessages.threeMinutes.showed = true;
				}
			}
		},
		logoutNotify(text, duration) {
			this.$vs.notify({
				title: 'Account beveiliging!',
				text: text + ' Direct opnieuw inloggen? klik dan hier.',
				color: 'danger',
				position: 'bottom-center',
				time: duration,
				click: () => {
					this.$store.dispatch('auth/signOut');
				}
			});
		},
		logoutNowNotify(delay) {
			setTimeout(() => {
				this.$vs.notify({
					title: 'Account beveiliging!',
					text: 'Je wordt nu uitgelogd!',
					color: 'danger',
					position: 'bottom-center',
					time: 4000,
				});
			}, delay);
		},
		calculateTokenExpireTimeInSeconds() {
			const now = new Date();
			const expireDate = new Date(this.tokenExpireTimeStamp);
			const diffInMs = expireDate - now;
			const diffInSec = Math.round(diffInMs / 1000);

			if (diffInSec < 0) {
				return 0;
			}

			return diffInSec;
		},
		checkTokenExpire() {
			const diffInSec = this.calculateTokenExpireTimeInSeconds();

			if (diffInSec > 0 && diffInSec < 300) {
				this.$store.dispatch('auth/refreshToken').then(() => {
					this.setCheckTokenExpireTimer();
				}).catch(() => {
					this.showLogoutNofify(diffInSec);

					this.setCheckTokenExpireTimer(5000);
				});
			} else {
				this.setCheckTokenExpireTimer();
			}
		},
		getWiki() {
			this.$store.dispatch('wiki/getWiki');
		},
		scrollToTop() {
			window.scrollTo({
				top:0,
				left: 0,
				behavior: 'smooth'
			})
		},
		scroll() {
			window.onscroll = () => {
				this.scrollToTopVisible = window.pageYOffset > 200;

			}
		}
	},
	mounted() {
		this.getWiki();
		this.toggleClassInBody(themeConfig.theme);
		this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

		const vh = window.innerHeight * 0.01;
		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty('--vh', `${vh}px`);

		this.scroll();
	},
	updated() {
		this.pushChatData();

		this.setCheckTokenExpireTimer();
	},
	async created() {
		const dir = this.$vs.rtl ? 'rtl' : 'ltr';
		document.documentElement.setAttribute('dir', dir);

		window.addEventListener('resize', this.handleWindowResize);
		window.addEventListener('scroll', this.handleScroll);

	},
	destroyed() {
		window.removeEventListener('resize', this.handleWindowResize);

		window.removeEventListener('scroll', this.handleScroll);
	}
}

</script>

<style>
/*Sometimes tooltips are behind objects*/
.vs-tooltip {
	z-index: 60000;
}

.vs-con-input-label {
	width: 100% !important;
}

/*change button height*/
.vs-button {
	padding-top: 8px !important;
	padding-bottom: 9px !important;
}

.vs-tabs--li button.vs-tabs--btn {
	z-index: unset;
}

/*Add z-index to select to make them visible above other content*/
/*.multiselect {*/
/*	z-index: 999;*/
/*}*/

/*.multiselect__element, .multiselect__option, .multiselect__content, .multiselect__content-wrapper {*/
/*	z-index: 10000;*/
/*}*/

.multiselect__content-wrapper {
	z-index: 5;
}

.multiselect--active .multiselect__content-wrapper {
	z-index: 1000;
}

.multiselect__tags {
	border: 1px solid rgba(0, 0, 0, 0.2);
	border-radius: 5px;
}

.multiselect {
	min-height: 37px;
	max-height: 35px;
}

.multiselect__select {
	height: 35px;
}

.multiselect__tags {
	height: 35px;
	min-height: 37px;
}

.multiselect-label {
	font-size: 0.85rem;
	color: rgba(0, 0, 0, .7);
	padding-left: 5px;
}
</style>